import { ContainerComponent, wrap } from 'AppReact';
import { BorderlessKeyInput, SecondaryTextSm } from 'atoms';
import Controller from './controller';
import { FlexBoxWrapper, FlexCenterWrapper } from 'wrappers';
import internalState from './internalState';

export const definition = {
  name: 'DateInput',
  controller: Controller,
  initialProps: ({ date, disablePastDates }) => {
    let day = '';
    let month = '';
    let year = '';

    if (!!date) {
      day = `${date?.getDate()}`;
      month = `${date?.getMonth() + 1}`;
      year = `${date?.getFullYear()}`;
    }
    return {
      date,
      day,
      month,
      year,
      disablePastDates
    }
  },
  props: internalState,
  elements: [
    {
      wrapper: FlexCenterWrapper,
      name: 'Wrapper',
      elements: [
        {
          wrapper: FlexBoxWrapper,
          name: 'MonthWrapper',
          ref: ({ monthInputRef }) => monthInputRef,
          elements: [
            {
              component: BorderlessKeyInput,
              name: 'Input',
              bindings: ({ day, month, year, dayInputRef, disablePastDates }) => ({ value: month ?? '', placeholder: 'MM', day, month, year, dayInputRef, disablePastDates }),
              displayState: ({ invalidDate }) => ({ minWidth: '26px', width: '26px', padding: '0px', color: invalidDate ? '#E41D1D' : null }),
            },
          ]
        },
        {
          component: SecondaryTextSm,
          name: 'FirstSlash',
          displayValue: ({ }) => '/'
        },
        {
          wrapper: FlexBoxWrapper,
          name: 'DayWrapper',
          ref: ({ dayInputRef }) => dayInputRef,
          elements: [
            {
              component: BorderlessKeyInput,
              name: 'Input',
              bindings: ({ day, month, year, monthInputRef, yearInputRef, disablePastDates }) => ({ value: day ?? '', placeholder: 'DD', day, month, year, monthInputRef, yearInputRef, disablePastDates }),
              displayState: ({ invalidDate }) => ({ minWidth: '26px', width: '26px', padding: '0px', color: invalidDate ? '#E41D1D' : null }),
            },
          ]
        },
        {
          component: SecondaryTextSm,
          name: 'SecondSlash',
          displayValue: ({ }) => '/'
        },
        {
          wrapper: FlexBoxWrapper,
          name: 'YearWrapper',
          ref: ({ yearInputRef }) => yearInputRef,
          elements: [
            {
              component: BorderlessKeyInput,
              name: 'Input',
              bindings: ({ day, month, year, dayInputRef, disablePastDates }) => ({ value: year ?? '', placeholder: 'YYYY', day, month, year, dayInputRef, disablePastDates }),
              displayState: ({ invalidDate }) => ({ minWidth: '35px', width: '35px', padding: '0px', color: invalidDate ? '#E41D1D' : null }),
            },
          ]
        },
      ]
    }
  ]
}

export default ContainerComponent(definition);